// Painel da área do afiliado: sem a sessão da área, volta ao login. Só no cliente,
// como o check-login.ts: o token mora no localStorage. Token vencido passa por aqui
// e cai no primeiro 401 da API (useAfiliadoApi).
//
// Na primeira carga (hidratação) não redireciona: o HTML do servidor ainda está
// sendo hidratado, e trocar de página agora dá mismatch. Ali quem decide é o
// onMounted de pages/[language]/afiliado/painel.vue.
export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server || useNuxtApp().isHydrating) return;

  if (!afiliadoStore().token) {
    return navigateTo({ name: "language-afiliado", params: { language: to.params.language } });
  }
});
